<template>
  <div>
    <q-dialog
      :visible="isVisible"
      :title="title"
      width="500px"
      :innerScroll="false"
      :showFooter="false"
      @close="onCancel"
    >
      <div class="content">
        <el-table :data="tableData" border :height="300" style="width: 100%" v-loading="loading">
          <el-table-column prop="storeName" label="店铺名称"></el-table-column>
          <el-table-column prop="allocationNum" label="总分配"></el-table-column>
          <el-table-column prop="actualSaleNum" label="已完成"></el-table-column>
          <el-table-column prop="completeRatio" label="完成率"></el-table-column>
        </el-table>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: "storeClearance",
  components: {},
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    modifyData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return  this.modifyData.title + '各店完成率';
    },
  },
  data() {
    return {
      loading: false,
      tableData: {
        
      },
      addForm: {},
      tableData: []
    };
  },
  methods: {
    init() {
      this.loading = true
      this.$q.clearanceManagement.completeInfoList({data: this.modifyData}).then(res => {
        this.tableData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    onCancel() {
      this.isVisible = false;
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.content {
  // max-height: 60vh;
  // overflow-y: auto;
}

.form-input {
  width: 200px;
}

.input-number {
  >>> .el-input__inner {
    text-align: left;
  }
}

>>> .el-form .el-form-item {
  margin-bottom: 22px;
}
</style>